<ng-template #container></ng-template>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/grid/grid-cell/grid-header-template-component.ts.GridHeaderTemplateComponent.html